import * as sup from "superstruct";

import { createResourceStruct } from "@/modules/api/utils/jsonApiStructs";
import { userIdentifierStruct } from "@/modules/auth/api/resources/user/userIdentifierStruct";
import { tutorialIdentifierStruct } from "@/modules/tutorials/api/resources/tutorial/tutorialIdentifierStruct";

import { subtaskIdentifierStruct } from "./subtaskIdentifierStruct";

export const subtaskResourceStruct = createResourceStruct({
  identifier: subtaskIdentifierStruct,
  attributes: sup.object({
    name: sup.string(),
    comment: sup.string(),
    description: sup.string(),
    pointsNumber: sup.integer(),
    completedAt: sup.nullable(sup.string()),
    rating: sup.nullable(sup.number()),
  }),
  relationships: sup.object({
    completedBy: sup.object({
      data: sup.nullable(userIdentifierStruct),
    }),
    tutorial: sup.object({
      data: sup.nullable(tutorialIdentifierStruct),
    }),
  }),
});

export type SubtaskResource = sup.Infer<typeof subtaskResourceStruct>;
